export { INPIHomeComponent } from './inpi-home.component';
export { INPIModule } from './inpi.module'

export type InpiFieldError = {
  name: string;
  current: string;
  valid: string;
}

export type INPIInfo = {
  message?: string;
  errors: InpiFieldError[];
}
